import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CheckSquare } from '@phosphor-icons/react';
import { useLanguage } from '../../contexts/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TaskItem = ({ task, onSelectTask }) => (
  <button
    onClick={() => onSelectTask(task.id)}
    data-testid={`contact-task-${task.id}`}
    className="w-full flex items-center justify-between gap-3 px-3 py-2.5 rounded-lg hover:bg-blue-50 text-left transition-colors"
  >
    <span className="flex items-center gap-2 min-w-0">
      <span className={`w-2 h-2 rounded-full flex-shrink-0 ${task.priority === 'High' ? 'bg-red-500' : task.priority === 'Medium' ? 'bg-amber-500' : 'bg-emerald-500'}`} />
      <span className={`truncate text-sm font-medium ${task.completed ? 'text-gray-400 line-through' : 'text-gray-900'}`}>{task.title}</span>
    </span>
    <span className="text-xs text-gray-500 flex-shrink-0">
      {task.due_date ? new Date(`${String(task.due_date).slice(0, 10)}T12:00:00`).toLocaleDateString() : ''}
    </span>
  </button>
);

// Tasks linked to a contact, shown in the desktop contact pane
export const ContactTasksSection = ({ contactId, onSelectTask }) => {
  const { t } = useLanguage();
  const tr = (key, fallback) => (t(key) === key ? fallback : t(key));
  const [tasks, setTasks] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/tasks`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        params: { contact_id: contactId, all: true },
      })
      .then((res) => setTasks((res.data || []).filter((task) => !task.archived)))
      .catch(() => setTasks([]));
  }, [contactId]);

  const open = (tasks || []).filter((task) => !task.completed);
  const done = (tasks || []).filter((task) => task.completed);

  return (
    <div className="mobile-card p-5 mb-4" data-testid="contact-tasks-section">
      <h3 className="flex items-center gap-2 font-display text-base font-semibold text-gray-900 mb-2">
        <CheckSquare size={20} weight="duotone" className="text-blue-600" />
        {t('tasks')}
        {tasks && <span className="text-xs font-medium text-gray-500">({open.length} {tr('open', 'open')})</span>}
      </h3>
      {tasks === null && <p className="text-sm text-gray-500 px-3 py-2">{tr('loading', 'Loading…')}</p>}
      {tasks && tasks.length === 0 && (
        <p className="text-sm text-gray-500 px-3 py-2" data-testid="contact-tasks-empty">{tr('noTasksForContact', 'No tasks linked to this contact yet.')}</p>
      )}
      {[...open, ...done].map((task) => <TaskItem key={task.id} task={task} onSelectTask={onSelectTask} />)}
    </div>
  );
};

export default ContactTasksSection;
